import "./Header.css";
import logo from "../assets/img/logo.png";
import whitelogo from "../assets/img/vit white logo.png";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
function Header() {
  return (
    <div>
      <header>
        <nav className="sticky-top">
          <div className="nav-content">
            <div className="nav-left-part">
              <div className="nav-image">
                <img src={logo} className="img-fluid" alt="VIT AP LOGO BLACK" />
              </div>
              <div className="nav-full">VIT AP</div>
              <div className="nav-image-tab">
                <p>Vellore Institute of Technology - AP</p>
                <p>ALUMNI ASSOCIATION</p>
              </div>
            </div>
            <div className="nav-right-part">
              <div className="nav-login">
                <Link
                  className="nav-link"
                  aria-current="page"
                  to="/login"
                  style={{ color: "black" }}
                >
                  Log in
                </Link>
              </div>
              <div className="nav-login">
                <Link
                  className="nav-link"
                  aria-current="page"
                  to="/register"
                  style={{ color: "black" }}
                >
                  Register
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <menu className="sticky-top topnav" id="myTopnav">
        <ul className="nav justify-content-center">
          <li className="nav-item">
            <Link className="nav-link" aria-current="page" to="/">
              HOME
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" aria-current="page" to="/about">
              ABOUT US
            </Link>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              ABOUT VITAA
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to="/about_vitaa">
                VITAA Core Committee Members
              </Link>
            </div>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/gallery">
              GALLERY
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/contact">
              CONTACT US
            </Link>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              MORE
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to="/query">
                Send us a query
              </Link>
              <Link className="dropdown-item" to="/atf">
                Academic Transcripts Form
              </Link>
              <Link className="dropdown-item" to="/migration_certificate">
                Migration Certificate
              </Link>
            </div>
          </li>
        </ul>
        <nav className="navbar navbar-light bg-light fixed-top">
          <div className="container-fluid nav-con">
            <div className="nav-left-part">
              <div className="nav-image">
                <img
                  src={whitelogo}
                  className="img-fluid"
                  alt="VIT AP LOGO BLACK"
                />
              </div>
              <div className="nav-image-tab">
                <p>VIT AP</p>
                <p>ALUMNI ASSOCIATION</p>
              </div>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="offcanvas offcanvas-end"
              tabIndex="-1"
              id="offcanvasNavbar"
              data-bs-scroll="true"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  ALUMNI RECONNECT
                </h5>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/about">
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle drop"
                      href="#"
                      id="offcanvasNavbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      About VITAA
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="offcanvasNavbarDropdown"
                    >
                      <li>
                        <Link className="dropdown-item" to="/about_vitaa">
                          VITAA Core Committee members
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/gallery"
                    >
                      Gallery
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/contact"
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle drop"
                      href="#"
                      id="offcanvasNavbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      More
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="offcanvasNavbarDropdown"
                    >
                      <li>
                        <Link className="dropdown-item" to="/query">
                          Send us a query
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/atf">
                          Academic Transcripts Form
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/migration_certificate"
                        >
                          Migration Certificate
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item login">
                      <Link className="nav-link" aria-current="page" to="/login">Login</Link>  
                  </li>
                  <li className="nav-item login">
                      <Link className="nav-link" aria-current="page" to="/register">Register</Link>  
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </menu>
    </div>
  );
}
export default Header;
